import { render, staticRenderFns } from "./ProfileStreamers.vue?vue&type=template&id=9b3fbdf4&"
import script from "./ProfileStreamers.vue?vue&type=script&lang=js&"
export * from "./ProfileStreamers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports